import React, { useEffect, useState, useRef, useContext } from 'react'
import _ from "lodash"
import { Row, Col, Card, CardBody, CardTitle } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import useFetchStatus from "customHooks/useFetchStatus"
import CustomTable from "../components/ReactTable"
import { updateDoc, getTicketStep2, handleTicket, addDate } from "../Tasks/handler"
import { UserContext } from "context/auth";
import PreviewModal from "main_views/Tasks/previewModal"
import i18n from 'utils/translation/i18n'

// Queries
const openTicketsQuery = { field: "inProgress", value: true },
   closeTicketsQuery = { field: "inProgress", value: false },
   completedTicketsQuery = { field: "isCompleted", value: true },
   approvedTicketsQuery = { field: "isApproved", value: true },
   canecledTicketsQuery = { field: "wasCanceled", value: true },
   rejectedTicketsQuery = [
      { field: "inProgress", value: false },
      { field: "isApproved", value: false },
      { field: "wasCanceled", value: false },
      { field: "isCompleted", value: false },
   ]

const intiPagination = { orderBy: 'number' }

function AllTickets() {

   let { t } = useTranslation()
   let { user: currentUser } = useContext(UserContext)

   
   let [selectedType, setSelectedType] = useState({})
   
   let [loadedTickets, setLoadedTickets] = useState([])
   let [ticketsUrl, setTicketsUrl] = useState('')
   let [pagination, setPagination] = useState(intiPagination)
   let [tickets, ticketError, isTicketLoading] = useFetchStatus(ticketsUrl, {}, [currentUser.id, pagination, selectedType, ticketsUrl], selectedType.query, false, pagination)

   let [staffs, staffsError, isStaffsLoading] = useFetchStatus(`staff`, {}, [], null)


   // preview Request Modal
   let [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false)
   let [previewingTicket, setPreviewTicket] = useState()


   // filter
   let [filteredItems, setFilteredItems] = useState()
   let [ticketList, setTicketList] = useState([])
   let [handeledTicketList, setHandeledTicketList] = useState([])
   let [isHandling, setHandling] = useState(false)


   // tickets counter
   let [ticketsCounter, setTicketsCounter] = useState({})

   // fetch the tickets counter info
   useEffect(() => {

      let counterDoc = window.firebaseFirestore.doc('counter/tickets')

      counterDoc.get().then(doc => {
         let { counter: all = 0, approved = 0, rejected = 0, completed = 0, canceled = 0 } = doc.data()
         let open = all - (approved + rejected + completed + canceled)
         let closed = (approved + rejected + completed + canceled)

         setTicketsCounter({ ...doc.data(), open, closed })

      })

   }, [])

   useEffect(() => {
      if (!_.isEmpty(selectedType) && _.isEmpty(ticketsUrl)) setTicketsUrl('tickets') // set url to start fetching

      // clear
      setLoadedTickets([])
      setPagination(intiPagination)

   }, [selectedType])

   useEffect(() => {
      setHandling(true)
      Promise.resolve(handler(tickets, staffs)).then(data => {
         setHandling(false)
         setHandeledTicketList(data)
      })
   }, [tickets])

   // merge the new fetched data with table body data
   useEffect(() => {
      setLoadedTickets(_.concat(loadedTickets, _.values(tickets)))
   }, [tickets])

   let fetchMoreData = () => {
      if (_.isEmpty(loadedTickets))
         return setPagination(intiPagination)

      let lastVisibleTicketNumber = _.last(_.values(tickets)).number
      setPagination({ ...pagination, lastVisible: lastVisibleTicketNumber })
   }

   const previewTicket = (index) => {
      setPreviewTicket(filteredItems[index])
      setIsPreviewModalOpen(true)
   }

   const Header = [
      {
         Header: "#",
         accessor: "number",
         type: "string",
         sortable: true,
      },
      {
         Header: t('requester_name'),
         accessor: "requesterName",
         type: "string",
         sortable: true,
      },
      {
         Header: t('form_name'),
         accessor: "form.name",
         type: "string",
         sortable: true,
      },
      {
         Header: t('due_date'),
         accessor: "dueDate",
         type: "firestoreTime",
         sortable: true,
      },
      {
         Header: t('priority'),
         accessor: "priority",
         type: "priorityTxt",
         sortable: true,
      },
      {
         Header: t('step'),
         accessor: "step",
         type: "string",
         sortable: true,
      },
      {
         Header: t('open_at'),
         accessor: "openedAt",
         type: "firestoreTime",
         sortable: true,
      },
      {
         Header: t('date_and_time'),
         accessor: "date",
         type: "dateAndTime",
         sortable: true,
      },
      {
         Header: " ",
         buttonTitle: t('preivew'),
         type: "button",
         color: "info",
         isOutline: true,
         sortable: false,
         onClick: previewTicket,
      },
   ]

   let handelTypeChanges = (type) => {

      if (type === selectedType.name) return // no changes

      let query = {}
      switch (type) {
         case 'open':
            query = {
               name: 'open',
               query: openTicketsQuery
            }
            break;

         case 'close':
            query = {
               name: 'close',
               query: closeTicketsQuery
            }
            break;

         case 'approved':
            query = {
               name: 'approved',
               query: approvedTicketsQuery
            }
            break;

         case 'rejected':
            query = {
               name: 'rejected',
               query: rejectedTicketsQuery
            }
            break;

         case 'completed':
            query = {
               name: 'completed',
               query: completedTicketsQuery
            }
            break;

         case 'canceled':
            query = {
               name: 'canceled',
               query: canecledTicketsQuery
            }
            break;

         default:
            query = {
               name: 'all',
               query: null
            }
            break;
      }

      setSelectedType(query)

   }

   return (
      <div className="content">

         <h5>{t('all_tickets')}</h5>

         {/* Counter */}
         <Row>
            <CardCounter
               title={'all_tickets'}
               ticketsNumbers={ticketsCounter.counter ?? 0}
               isSelect={selectedType.name === 'all'}
               onClick={() => handelTypeChanges('all')}
            />
            <CardCounter
               title={'open_tickets'}
               ticketsNumbers={ticketsCounter.open ?? 0}
               isSelect={selectedType.name === 'open'}
               onClick={() => handelTypeChanges('open')}
            />
            <CardCounter
               title={'closed_tickets'}
               ticketsNumbers={ticketsCounter.closed ?? 0}
               isSelect={selectedType.name === 'close'}
               onClick={() => handelTypeChanges('close')}
            />
         </Row>

         <Row>
            <CardCounter
               title={'approved'}
               ticketsNumbers={ticketsCounter.approved ?? 0}
               onClick={() => handelTypeChanges('approved')}
               isSelect={selectedType.name === 'approved'}
               icon={``}
            />
            <CardCounter
               title={'rejected'}
               ticketsNumbers={ticketsCounter.rejected ?? 0}
               onClick={() => handelTypeChanges('rejected')}
               isSelect={selectedType.name === 'rejected'}
               icon={``}
            />
            <CardCounter
               title={'completed'}
               ticketsNumbers={ticketsCounter.completed ?? 0}
               onClick={() => handelTypeChanges('completed')}
               isSelect={selectedType.name === 'completed'}
               icon={``}
            />
            <CardCounter
               title={'canceled'}
               ticketsNumbers={ticketsCounter.canceled ?? 0}
               onClick={() => handelTypeChanges('canceled')}
               isSelect={selectedType.name === 'canceled'}
               icon={``}
            />
         </Row>

         {/*Display Tickets list */}
         {!_.isEmpty(ticketsUrl) && (
            <CustomTable
               title={`${t('all_requests')} ${selectedType.name !== 'all' ? `- ${t(selectedType.name)}`: ''}`}
               header={Header}
               loading={isTicketLoading || isHandling}
               body={loadedTickets}
               hasSearchBar={true}
               searchBarTitle={t('search')}
               setFilterResult={setFilteredItems}
               selectDateRangeBeforeExport={true}
               dataQuery={selectedType.query} // for search & export 
               dataHandler={(allTickets) => handler(allTickets, staffs)} // to handel the data after fetch
               loadMoreBtn={{
                  onClick: fetchMoreData,
                  isDisabled: !isTicketLoading && _.isEmpty(tickets)
               }}
            />
         )}

         {/* Preview ticket modal */}
         {previewingTicket && (
            <PreviewModal
               isOpen={isPreviewModalOpen}
               toggle={() => setIsPreviewModalOpen(false)}
               ticket={previewingTicket}
               staffs={staffs}
            />
         )}

      </div>

   )
}

export default AllTickets


async function handler(tickets, staffs) {

   let filteredTickets = await Promise.all(_.map(tickets, (ticket) => ticket = addDate(ticket)))

   filteredTickets = await getTicketStep2(filteredTickets, staffs)

   return filteredTickets

}

let CardCounter = ({ title, ticketsNumbers, onClick, isSelect, icon }) => (
   <Col>
      <Card
         className="card-stats"
         style={{ cursor: 'pointer', backgroundColor: isSelect ? 'floralwhite' : 'white' }}
         onClick={onClick}
      >
         <CardBody>
            <Row>
               <Col md="4" xs="5">
                  <div className="icon-big text-center icon-warning">

                     {icon ?? <i className="nc-icon nc-single-copy-04 text-success" />}

                  </div>
               </Col>
               <Col md="8" xs="7">
                  <div className="numbers">
                     <p className="card-category">{i18n.t(title)}</p>
                     <CardTitle tag="p">{ticketsNumbers}</CardTitle>
                     <p />
                  </div>
               </Col>
            </Row>
         </CardBody>
      </Card>
   </Col>
)
